<template>
  <div id="contacted-suppliers" style="margin-bottom: 100px">
    <b-dropdown
      size="sm"
      text="Products"
      block
      variant="primary"
      class="dropdown w-full"
      v-if="isMobile"
    >
      <b-dropdown-item-button
        @click="goToChat(value.uuid)"
        v-for="(value, index) in products"
        :key="index"
        >{{ value.name }}</b-dropdown-item-button
      >
    </b-dropdown>
    <div class="d-flex w-100">
      <div
        class="w-25 p-2"
        style="border: 1px solid #f3e5e5; border-right: none"
        v-if="!isMobile"
      >
        <ContentLoader v-if="!products.length" />
        <div
          class="card mb-2"
          v-for="(value, index) in products"
          :key="index"
          v-else
        >
          <div class="card-body" @click="goToChat(value.uuid)">
            <h6 class="card-title uppercase m-0">{{ value.name }}</h6>
          </div>
        </div>
      </div>
      <div
        class="p-2"
        :class="[isMobile ? 'w-100' : 'w-75']"
        style="height: 600px; position: relative; border: 2px solid #f3e5e5"
      >
        <ContentLoader v-if="!messages.length" />
        <div class="p-2 product-details d-flex" v-else>
          <div>
            <img
              :src="selectedProduct.image"
              alt="product-image"
              style="height: 48px"
            />
          </div>
          <div style="padding-left: 10px">
            <strong
              ><router-link :to="'/products/' + selectedProduct.uuid">{{
                selectedProduct.name
              }}</router-link></strong
            >
            <p>
              <router-link
                :to="
                  '/suppliers/' +
                  $optional(selectedProduct, 'supplier.uuid', 'N/A')
                "
                >{{
                  $optional(selectedProduct, 'supplier.name', 'N/A')
                }}</router-link
              >
            </p>
          </div>
        </div>
        <div class="chat" id="chat">
          <div
            class="d-flex flex-column"
            v-for="(value, index) in messages"
            :key="index"
          >
            <div
              :class="[
                value.is_sent_by_supplier
                  ? 'align-self-start supplier-chat'
                  : 'align-self-end buyer-chat'
              ]"
              class="chat-message"
            >
              {{ value.msg_body }}
              <p class="no-margin" style="font-size: 12px; text-align: right">
                {{ value.sent_at | formatDate }}
              </p>
            </div>
          </div>
        </div>
        <div class="form-wrapper" v-if="messages.length">
          <form @submit.prevent="sendReply">
            <div class="form-group d-flex" style="height: 50px">
              <textarea
                placeholder="type you message here..."
                v-model="form.message"
                class="form-control no-radius message-input"
                rows="3"
                required
              ></textarea>
              <button
                type="submit"
                class="btn btn-primary no-radius send-message-btn"
              >
                <i class="fa fa-paper-plane" v-if="!sendingReply"></i>
                <ButtonLoader v-if="sendingReply" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { contactSupplier } from '@/api/services/supplier'
import { getProduct } from '@/api/services/product'
export default {
  props: {
    data: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      products: [],
      selectedProduct: {},
      messages: [],
      form: {},
      sendingReply: false
    }
  },
  mounted() {
    if (this.isMobile) {
      document.querySelector('.dropdown-menu').style.width = '100%'
    }
    this.getProducts()
  },
  methods: {
    getProducts() {
      this.products = []
      this.products = this.data

      if (+localStorage.getItem('product-id')) {
        this.selectedProduct = this.products.find(
          (val) => val.id === JSON.parse(localStorage.getItem('product-id'))
        )
        localStorage.removeItem('profile-active-tab')
        localStorage.removeItem('product-id')
      } else {
        this.selectedProduct = this.products[0]
      }

      this.messages = this.selectedProduct.orders[
        +Object.keys(this.selectedProduct.orders)
      ].order_messages
    },
    async goToChat(productId) {
      this.messages = []
      let { data } = await getProduct(productId)
      this.selectedProduct = data
      this.messages = this.selectedProduct.orders[
        +Object.keys(this.selectedProduct.orders)
      ].order_messages
      this.scrollToBottom()
    },
    async sendReply() {
      this.sendingReply = true
      this.form.supplier_id = this.selectedProduct.supplier_id
      this.form.product_id = this.selectedProduct.id
      this.form.pickup_email = this.$user.email
      this.form.subject = 'Buyer Reply'

      await contactSupplier(this.form)
      this.reloadConversation()
    },
    async reloadConversation() {
      let { data } = await getProduct(this.selectedProduct.uuid)
      this.messages = data.orders[+Object.keys(data.orders)].order_messages
      setTimeout(() => {
        this.scrollToBottom()
        this.sendingReply = false
        this.form.message = ''
      }, 1000)
    },
    scrollToBottom() {
      var chat = document.getElementById('chat')
      chat.scrollTop = chat.scrollHeight
    }
  }
}
</script>
<style lang="scss" scoped>
.product-link {
  &:hover {
    text-decoration: none;
  }
}
.message-input {
  height: 50px;
  &:focus {
    box-shadow: none !important;
    border-color: none !important;
  }
}
.send-message-btn {
  &:focus {
    box-shadow: none !important;
    border-color: none !important;
  }
}
.chat-message {
  width: 40%;
  margin-bottom: 10px;
  border-radius: 20px;
  padding: 10px 20px;
  color: #fff;
  @media screen and (min-width: 320px) and (max-width: 425px) {
    width: 70%;
  }
}
.supplier-chat {
  background: #17a2b8;
}
.buyer-chat {
  background: #35495e;
}
.form-wrapper {
  height: 70px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 10px;
}
.chat {
  margin-top: 80px;
  height: 435px;
  overflow-y: scroll;
  width: 100%;
  @media screen and (min-width: 320px) and (max-width: 425px) {
    margin-top: 55px;
    height: 463px;
  }
}
.product-details {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 65px;
  border-bottom: 2px solid #f3e5e5;
}
ul.dropdown-menu {
  width: 100% !important;
}
</style>